import { cn } from "@/lib/utils";

export function PageHeader({ title, subtitle, children, breadcrumb }) {
  return (
    <div className="mb-6">
      {breadcrumb && <div className="mb-2 text-xs text-muted-foreground">{breadcrumb}</div>}
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h1 className="font-display text-2xl font-bold tracking-tight text-foreground">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-2 flex-wrap">{children}</div>
      </div>
    </div>
  );
}

export function Section({ title, action, className, children, testid }) {
  return (
    <div data-testid={testid} className={cn("rounded-2xl border border-border/60 bg-card shadow-sm", className)}>
      {(title || action) && (
        <div className="flex items-center justify-between border-b border-border/60 px-4 py-3">
          <h3 className="font-display text-sm font-semibold text-foreground">{title}</h3>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
